export function polishRepoPreviewURL<
  PreviewURL extends string | undefined | null,
>(previewUrl: PreviewURL): PreviewURL {
  if (!previewUrl) return previewUrl
  try {
    const url = new URL(previewUrl)
    if (url.href.endsWith('/')) {
      return url.href.slice(0, -1) as PreviewURL
    } else {
      return url.href as PreviewURL
    }
  } catch (error) {
    return previewUrl
  }
}
